const digest = '063b7d4b73f409d472b5afebac5e0ae9fcabe6db61665873517e318470d98997';
const css = `body{background-attachment:fixed;background-color:#f5f5f5;background-image:url(https://www.aexp-static.com/cdaas/one/statics/@americanexpress/static-assets/2.29.1/package/dist/img/brand/worldservice-tile-gray.svg);background-repeat:repeat}.loading-container{align-items:center;display:flex;justify-content:center;min-height:100vh}.text-underline-none{text-decoration:none}.text-underline-none:focus{outline:none}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default {  };

export { css, digest };